import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import a, { useMemo as D } from "react";
import g from "react-flatpickr";
var k = function k(_ref) {
  var p = _ref.placeholder,
    r = _ref.inputComponent,
    m = _ref.className,
    e = _ref.name,
    t = _ref.form;
  var n = t.formSchema[e],
    u = function u(o) {
      t.setFieldValue(e, o), setTimeout(function () {
        t.focusOn(n.focusOnNext);
      }, 0);
    },
    c = D(function () {
      var s, i;
      var o = (s = n == null ? void 0 : n.options) == null ? void 0 : s.minDateFrom;
      if (!o) return _objectSpread({}, n.options);
      var l = o ? (i = t.state[o].value) == null ? void 0 : i[0] : null;
      return _objectSpread(_objectSpread({}, n.options), {}, {
        minDate: l || void 0
      });
    }, [t.state]);
  return a.createElement(g, {
    className: m,
    onChange: u,
    options: c
  }, a.createElement(r, {
    placeholder: p,
    form: t,
    name: e,
    containerRef: t.refs[e]
  }));
};
export { k as DateInput };